import {Controller} from "stimulus";
import $ from "jquery";

export default class extends Controller {
  static targets = [
    "modal",
  ];

  connect() {
    this.initializeControls();
    this.emailSyncWithModal();
    if (this.shouldOpenModal()) {
      this.openModal();
    }
    if (this.shouldOpenReviewModal()) {
      this.openReviewModal();
    }
  }

  initializeControls() {
    const sendButton = document.querySelector('.send-btn');
    sendButton?.addEventListener("click", () => {
      this.sendAsGuest();
    });
  }

  emailSyncWithModal() {
    const bookingEmailInput = document.getElementById('email');
    const modalEmailInput = document.getElementById('user_modal_email');

    bookingEmailInput.addEventListener('input', function () {
        modalEmailInput.value = bookingEmailInput.value;
    });
  }

  shouldOpenModal() {
    return window.location.search.includes('modal_message_sent=true')
  }

  shouldOpenReviewModal() {
    const withoutUser = $(".navbar-nav").length > 0;
    const alertText = $(".alert-info span").text();
    const verificationSent = this.data.element.dataset.verification_resent;
    const verificationResent = this.data.element.dataset.verification_sent;
    return (
        withoutUser &&
        !alertText.includes(verificationSent) &&
        !alertText.includes(verificationResent)
    );
  }

  openModal() {
    $('#modal__message_sent').modal('show');

    setTimeout(function() {
      window.history.replaceState({}, document.title,window.location.href.split("?")[0]);
    },0);
  }

  openReviewModal() {
    $('#modal__review_email').modal('show');
  }

  sendAsGuest() {
    event.preventDefault();
    const sendButton = document.querySelector('.send-btn');
    const formId = sendButton.dataset["form"];
    const form = document.getElementById(formId);
    const method = form.getAttribute("data-method");
    const action = form.getAttribute("data-action");

    let industryArray = document.querySelectorAll('#' + formId + ' .industry option');
    const selectedIndustry = [];
    industryArray.forEach(industry => {
      if (industry['selected']) {
        selectedIndustry.push(industry.value);
      }
    });

    let dataToSend = {
      locale: document.querySelector('#' + formId + ' #booking_locale').value,
      first_name: document.querySelector('#' + formId + ' #first_name').value,
      last_name: document.querySelector('#' + formId + ' #last_name').value,
      business_type: document.querySelector('#' + formId + ' #business_type').value,
      organization: document.querySelector('#' + formId + ' #organization').value,
      email: document.querySelector('#' + formId + ' #email').value,
      password: document.querySelector('#' + formId + ' #password').value,
      password_confirmation: document.querySelector('#' + formId + ' #password_confirmation').value,
      account_type: document.querySelector('#' + formId + ' #account_type').value,
      industry: document.querySelector('#' + formId + ' #industry').value,
      country: document.querySelector('#' + formId + ' #country').value
    };

    $.ajax({
      url: action,
      type: method,
      dataType: "json",
      data: {
        booking: dataToSend
      },
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      beforeSend: function() {
        document.querySelector('.loader')?.classList.remove('is-hidden');

        const requiredFields = [
          { selector: '#first_name', errorId: 'first-name-error' },
          { selector: '#last_name', errorId: 'last-name-error' },
          { selector: '#business_type', errorId: 'business_type-error' },
          { selector: '#email', errorId: 'email-error' },
          { selector: '#password', errorId: 'password-error' },
          { selector: '#password_confirmation', errorId: 'password-confirmation-error' },
          { selector: '#account_type', errorId: 'account-type-error' },
          { selector: '#industry', errorId: 'industry-error' },
          { selector: '#country', errorId: 'country-error' }
        ];

        const businessTypeValue = document.querySelector('#business_type').value.trim();
        if (businessTypeValue !== 'individual') {
          requiredFields.push({ selector: '#organization', errorId: 'organization-error' });
        }

        let isValid = true;

        requiredFields.forEach(field => {
          const businessType = document.getElementById('organization')
          const businessTypeError = document.getElementById('organization-error')
          if (businessType && businessTypeError && businessType.innerText === '') {
            businessTypeError.innerText = '';
          }
          const errorElement = document.getElementById(field.errorId);
          if (errorElement) {
            errorElement.textContent = '';
            errorElement.classList.add = 'is-hidden';
          }
        });

        requiredFields.forEach(field => {
          const value = document.querySelector(field.selector).value.trim();

          if (!value) {
            isValid = false;
            const errorElement = document.getElementById(field.errorId);
            const errorMessage = sendButton.dataset["errorMessage"];
            if (errorElement) {
              errorElement.textContent = errorMessage;
              errorElement.classList.remove('is-hidden');
            }
          }
        });

        const password = document.querySelector('#password').value.trim();
        const passwordConfirmation = document.querySelector('#password_confirmation').value.trim();
        const passwordConfirmationErrorElement = document.getElementById('password-confirmation-error');

        if (password !== passwordConfirmation) {
          isValid = false;
          if (passwordConfirmationErrorElement) {
            const sendButton = document.querySelector('.send-btn');
            passwordConfirmationErrorElement.textContent = sendButton.dataset["confirmationErrorMessage"];
            passwordConfirmationErrorElement.classList.remove('is-hidden');
          }
        }

        if (!isValid) {
          return false;
        }
      }
    }).done((data) => {
      document.querySelector('.loader')?.classList.add('is-hidden')
      let asGuestModal = '#modal__as_guest'
      let verifyEmailModal = '#modal__verify_email'
      $(asGuestModal).modal('hide');
      $(verifyEmailModal).modal('show');
      document.querySelector('#project_template_user_id').value = data.user_id
      document.getElementById('project_template_prices_from').dataset.currency = data.currency
      document.getElementById('project_template_prices_to').dataset.currency = data.currency
      $('#your-project').trigger('click')
      history.replaceState(null, '', '?guest_token=' + data.guest_token);
    }).fail((data) => {
      const errors = data?.responseJSON?.errors;

      for (const field in errors) {
        if (errors.hasOwnProperty(field)) {
          if (!errors[field]) continue;
          const errorMessages = Array.isArray(errors[field]) ? errors[field] : [errors[field]];
          const errorMessage = errorMessages.join(', ');
          $('#' + field + '-error').text(errorMessage).show();
        }
      }

      document.querySelector('.loader')?.classList.add('is-hidden')

      const signInButton = document.querySelector('.sign-in-btn');
      const checkConfirmation = document.querySelector('.check-confirmation');

      if (signInButton) {
        signInButton.classList.add('is-hidden')
      }
      if (checkConfirmation) {
        checkConfirmation.classList.add('is-hidden')
      }
      if (data?.responseJSON?.errors?.sign_in === true && signInButton) {
        signInButton.classList.remove('is-hidden')
      }
      if (data?.responseJSON?.errors?.resend_confirmation === true && checkConfirmation) {
        checkConfirmation.classList.remove('is-hidden')
      }
    })
  }
}
